/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jade_Keen_Duck_ReadInputs */

const en_jade_keen_duck_read = /** @type {(inputs: Jade_Keen_Duck_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access Rights and Permissions`)
};

const de_jade_keen_duck_read = /** @type {(inputs: Jade_Keen_Duck_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugriffsrechte und Berechtigungen`)
};

/**
* | output |
* | --- |
* | "Access Rights and Permissions" |
*
* @param {Jade_Keen_Duck_ReadInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const jade_keen_duck_read = /** @type {((inputs?: Jade_Keen_Duck_ReadInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jade_Keen_Duck_ReadInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jade_keen_duck_read(inputs)
	return de_jade_keen_duck_read(inputs)
});